import { Banner } from "@/components/ui/banner"
import { FormError } from "@/components/ui/form"

const CareProviderSearchError = (props: { betterDocError?: string; error?: string }) => {
  const { betterDocError, error } = props

  if (betterDocError) {
    return (
      <Banner variant="critical" className="mt-1 rounded-md">
        {betterDocError}
      </Banner>
    )
  }

  return error && <FormError>{error}</FormError>
}

export default CareProviderSearchError
